import { Map } from 'immutable';

import { RECEIVE_RMAS } from '@sophocles/entities/Rma/rmaActions';

export function rmaReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_RMAS: // Read
      return state.merge(action.rmas);
    default:
      return state;
  }
}
